/**
 * Created by Administrador on 07/08/2019.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('levelOfSaleReservationsService',levelOfSaleReservationsService);

    levelOfSaleReservationsService.$inject = ['$http', 'CONFIG','messageService'];

    function levelOfSaleReservationsService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_REPORT + '/' + CONFIG.API + '/report-level-of-sales-flight';

        var service = {
            getLevelOfSaleReservationByFlight: getLevelOfSaleReservationByFlight
        };

        return service;

        function getLevelOfSaleReservationByFlight(flightId){
            return $http.get(urlBase + '/' + flightId )
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }
    }
})();
